import { Card } from '@/common/ui/Card'
import { AddTokensForm } from '@/app/entities/addTokens'

export const AdditionalTokensCard = () => {
    return (
        <Card>
            <div className='flex flex-col gap-6'>
                <h3 className='text-lg font-medium'>Дополнительные токены</h3>
                <AddTokensForm />
            </div>
        </Card>
    )
}
